var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component",attrs:{"props":_vm.props,"tracker":_vm.tracker,"children":_vm.children},on:{"edit-tr":function($event){return _vm.$emit('edit-tr', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }